<div class="modal-header">
  <h2>Confirm license package change</h2>
</div>

<hr />

<div class="modal-body">
  <div class="row">
    <div class="col">
      <p>
        <b>If the package change will add new licenses:</b> Account sections
        will be bootstrapped and this is not reversible.
      </p>
      <p>
        <b>If the package change will remove licenses:</b> Licenses will be
        turned off, but sections will keep the bootstrapped licenses.
      </p>
      <p>
        You're about to change the account license package from
        <b>{{ licensePackage?.displayName }}</b> to
        <b>{{ switchToPackage?.displayName }}</b
        >.
      </p>
      <p class="warning">
        <i class="fa fa-exclamation-triangle"></i> When changing the license package you may need to adjust the account limits.
      </p>
    </div>
  </div>

  <div *ngIf="licensePackage" class="row justify-content-center">
    <div class="col-auto">
      <app-account-package
        [package]="licensePackage?.displayName"
        [licenses]="licensePackage?.licenses"
        [innerId]="'currentPackage-' + licensePackage?.code"
        [selected]="accountDetails?.licensePackage === licensePackage?.code"
      >
      </app-account-package>
    </div>
  </div>
  <ng-container *ngIf="switchToPackage">
    <div class="row justify-content-center">
      <i class="fas fa-arrow-down"></i>
    </div>
    <div class="row justify-content-center">
      <div class="col-auto">
        <div class="new-package">
          <app-account-package
            [package]="switchToPackage?.displayName"
            [licenses]="switchToPackage?.licenses"
            [innerId]="'newPackage-' + switchToPackage?.code"
            [selected]="!!switchToPackage?.code"
          >
          </app-account-package>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<hr />

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
    [disabled]="state === formStates.submitting"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-success"
    (click)="onConfirm()"
    [disabled]="state === formStates.submitting"
  >
    Confirm
  </button>
</div>

<div *ngIf="state === formStates.submitting" class="loading">
  <app-loading-spinner></app-loading-spinner>
</div>
